import React from "react";
import { Reveal } from "@/components/Reveal";

export const SectionHeading = ({ overline, title, subtitle, align = "left", accentWord, className = "" }) => {
  const renderTitle = () => {
    if (!accentWord) return title;
    const parts = title.split(accentWord);
    return (
      <>
        {parts[0]}
        <span className="italic text-gold-gradient">{accentWord}</span>
        {parts[1]}
      </>
    );
  };
  return (
    <div className={`${align === "center" ? "mx-auto text-center" : "text-left"} max-w-2xl ${className}`}>
      <Reveal>
        <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.22em] text-gold">
          <span className="h-px w-6 bg-gold" />
          {overline}
        </span>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-4 font-serif text-4xl font-light leading-[1.08] tracking-tight text-charcoal sm:text-5xl">
          {renderTitle()}
        </h2>
      </Reveal>
      {subtitle && (
        <Reveal delay={0.16}>
          <p className="mt-5 text-lg leading-relaxed text-charcoal-soft">{subtitle}</p>
        </Reveal>
      )}
    </div>
  );
};
